import { useState, useEffect } from "react";

export type IUseScreenSizeReturnType = {
  isMobile: boolean;
  isTablet: boolean;
  isLaptop: boolean;
};
const useScreenSize = (): IUseScreenSizeReturnType => {
  const [screenSize, setScreenSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  useEffect(() => {
    const handleResize = () => {
      setScreenSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };

    window.addEventListener("resize", handleResize);

    // Clean up the event listener when the component unmounts
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return screenSize?.width >= 395 && screenSize?.width <= 450
    ? {
        isLaptop: false,
        isMobile: true,
        isTablet: false,
      }
    : screenSize?.width >= 450 && screenSize.width <= 840
    ? {
        isLaptop: false,
        isMobile: false,
        isTablet: true,
      }
    : {
        isLaptop: true,
        isMobile: false,
        isTablet: false,
      };
};

export default useScreenSize;
